import { useQuery } from 'react-query'
import { suporteService } from '../services/suporte'
import { SuporteFilters, SuporteFormData } from '../tipos/suporte'
import { useMutationWithToast } from '../../../hooks/useMutationWithToast'
import { useToast } from '../../../contexts/NotificationContext'

export function useSuportes(filters?: SuporteFilters) {
  const toast = useToast()

  return useQuery(['suportes', filters], () => suporteService.listarSuportes(filters), {
    keepPreviousData: true,
    onError: (error: any) => {
      const mensagem = error?.message || 'Erro ao carregar suportes'
      toast.error(mensagem)
    },
  })
}

export function useSuporte(id?: number) {
  const toast = useToast()

  return useQuery(['suporte', id], () => suporteService.getSuporteById(id!), {
    enabled: !!id,
    onError: (error: any) => {
      const mensagem = error?.message || 'Erro ao carregar suporte'
      toast.error(mensagem)
    },
  })
}

export function useCreateSuporte() {
  return useMutationWithToast<SuporteFormData, SuporteFormData>({
    mutationFn: suporteService.criarSuporte,
    successMessage: 'Suporte criado com sucesso!',
    errorMessage: 'Erro ao criar suporte',
    invalidateQueries: 'suportes',
  })
}

export function useUpdateSuporte() {
  return useMutationWithToast<SuporteFormData, { id: number; data: SuporteFormData }>({
    mutationFn: ({ id, data }) => suporteService.atualizarSuporte(id, data),
    successMessage: 'Suporte atualizado com sucesso!',
    errorMessage: 'Erro ao atualizar suporte',
    invalidateQueries: ['suportes', 'suporte'],
  })
}

export function useDeleteSuporte() {
  return useMutationWithToast<void, number>({
    mutationFn: suporteService.excluirSuporte,
    successMessage: 'Suporte excluído com sucesso!',
    errorMessage: 'Erro ao excluir suporte',
    invalidateQueries: 'suportes',
  })
}
